import React from "react";
import styled from "styled-components";
import {GreyContent, White} from "../../../theme/variable";
import ArrowContentLoader from "../../../images/Arrow-ContentLoader.png";
import {loaderanimationRule} from "../../CommonContentLoaderStyled/widgets/Styled";

export const RangeLoader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0 20px;
`;
export const RangeSliderLoader = styled.div`
    width: 75%;
    background: ${GreyContent};
    height: 4px;
    position: relative;
    &:after {
        content: "";
        background: url(${ArrowContentLoader}) no-repeat;
        position: absolute;
        left: 50%;
        top: -11px;
        display: inline-block;
        width: 28px;
        height: 28px;
    }
`;
export const RangeValueField = styled.div`
    && {
        border: 1px solid #eee;
        border-radius: 4px;
        height: 32px;
        line-height: 32px;
        width: 22%;
        background: ${White};
        span {
            height: 16px;
            background: ${GreyContent};
            margin-top: 7px;
            display: block;
            width: 80%;
            margin-left: 7px;
            animation: ${loaderanimationRule};
        }
    }
`;
export const RangeMinMaxLoader = styled.div`
    position: absolute;
    top: 20px;
    width: 100%;
    > span {
        background: ${GreyContent};
        height: 16px;
        width: 40px;
        position: absolute;
        left: 0;
        animation: ${loaderanimationRule};
        &:last-child {
            right: 0;
            left: auto;
        }
    }
`;
export const RangeInputLoader = () => {
    return (
        <React.Fragment>
            <RangeLoader>
                <RangeSliderLoader>
                    <RangeMinMaxLoader>
                        <span />
                        <span />
                    </RangeMinMaxLoader>
                </RangeSliderLoader>
                <RangeValueField>
                    <span />
                </RangeValueField>
            </RangeLoader>
        </React.Fragment>
    );
};
export default RangeInputLoader();
